import React from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useToaster } from '../../../Toaster/Toaster';
interface ConfirmationProps {
  onClose: () => void;
  onConfirm: () => void;
  isUpdate: string;
  bookingTypes?: string;
  nameOfScreen: string;
  isApproval?: string;
  statusValue: string;
  role?: string;
}
const ConfirmationModal: React.FC<ConfirmationProps> = ({
  onClose,
  onConfirm,
  isUpdate,
  bookingTypes,
  nameOfScreen,
  isApproval,
  statusValue,
  role,
}) => {
  console.log(
    nameOfScreen,
    isApproval,
    isUpdate,
    statusValue,
    bookingTypes,
    role
  );
  const navigate = useNavigate();
  const { showToast } = useToaster();

  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

  console.log('userRole', userInfo?.roles === 'PUBLISHER');
  return ReactDOM.createPortal(
    <div className='fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30'>
      <div className='bg-white rounded-lg shadow-lg overflow-hidden sm:w-1/3 md:w-1/3 w-10/12'>
        <div className='p-4'>
          <div className='flex items-center justify-center'>
            <div className='ml-4'>
              {nameOfScreen === 'users' && (
                <h3 className='text-lg font-medium text-gray-900 text-center'>
                  Confirmation!{' '}
                </h3>
              )}

              <h3 className='text-lg font-medium text-gray-900 text-center'>
                {nameOfScreen === 'leads' && isUpdate === 'update'
                  ? 'Update Lead Confirmation'
                  : nameOfScreen === 'leads' && isUpdate !== 'update'
                  ? 'Save Lead Confirmation'
                  : isUpdate === 'adminTrail'
                  ? 'Activate Vendor Dashboard'
                  : isUpdate === 'adminInvite'
                  ? ' Invite & Activate Vendor Dashboard'
                  : isUpdate === 'TRIAL'
                  ? 'Activate Vendor Dashboard'
                  : isUpdate === 'INVITE'
                  ? 'Activate Vendor Dashboard'
                  : nameOfScreen === 'converToLeads'
                  ? 'Confirm Proposal Conversion?'
                  : ''}
              </h3>

              {nameOfScreen === 'companies' && (
                <h3 className='text-lg font-medium text-gray-900 text-center'>
                  {isUpdate == 'update'
                    ? 'Company Update Confirmation '
                    : 'Company save Confirmation '}{' '}
                </h3>
              )}

              {nameOfScreen === 'proposals' && (
                <h3 className='text-lg font-medium text-gray-900 text-center'>
                  {isUpdate == 'update'
                    ? 'Update Information'
                    : isUpdate == 'updateConfirmBooking'
                    ? 'Confirm Update'
                    : isUpdate == 'confirmBook'
                    ? 'Confirm Submission'
                    : isUpdate !== 'TRIAL' &&
                      isUpdate !== 'INVITE' &&
                      isUpdate !== 'adminTrail' &&
                      isUpdate !== 'adminInvite'
                    ? 'Save Proposal Confirmation'
                    : ''}
                </h3>
              )}

              {nameOfScreen === 'bookings' && (
                <h3 className='text-lg font-medium text-gray-900 text-center'>
                  Booking Confirmation
                </h3>
              )}

              {nameOfScreen === 'posts' && (
                <>
                  {isApproval === 'draft' && (
                    <>
                      <h3 className='text-lg font-medium text-gray-900 text-center'>
                        Save as Draft?
                      </h3>
                      <p className='text-base text-gray-500 text-center mt-2'>
                        Are you sure you want to save this post as a draft? You
                        can save your progress and submit it for review once
                        it's ready.
                      </p>
                    </>
                  )}
                  {isApproval === 'approval' && (
                    <>
                      <h3 className='text-lg font-medium text-gray-900 text-center'>
                        {statusValue === 'SAVED_AS_DRAFT' &&
                        role !== 'JE' &&
                        role !== 'CE' &&
                        userInfo?.roles === 'PUBLISHER'
                          ? 'Confirm Post Publication'
                          : isUpdate === 'update' && statusValue === 'PUBLISHED'
                          ? 'Confirm Overwrite'
                          : role === 'CE'
                          ? 'Send Approval to Chief Editor?'
                          : role === 'JE'
                          ? 'Send Approval to Junior Editor?'
                          : role === 'Publisher' &&
                            userInfo?.roles !== 'PUBLISHER'
                          ? 'Send Approval to Publisher?'
                          : 'Confirm Post Publishing'}
                      </h3>

                      <p className='text-base text-gray-500 text-center mt-2'>
                        {statusValue === 'SAVED_AS_DRAFT' &&
                        role !== 'JE' &&
                        role !== 'CE' &&
                        userInfo?.roles === 'PUBLISHER'
                          ? 'Are you sure you want to publish this post? Once published, it will be live for readers to view.'
                          : isUpdate === 'update' && statusValue === 'PUBLISHED'
                          ? 'Are you sure you want to publish these changes? This will overwrite the previously published content for this post.'
                          : role === 'JE'
                          ? "Are you sure you want to send this post for approval to the Junior Editor? Once submitted, you won't be able to make further edits."
                          : role === 'CE'
                          ? "Are you sure you want to send this post for approval to the Chief Editor? Once submitted, you won't be able to make further edits."
                          : role === 'Publisher' &&
                            userInfo?.roles !== 'PUBLISHER'
                          ? "Are you sure you want to send this post for approval to the Publisher? Once submitted, you won't be able to make further edits."
                          : 'Are you sure you want to publish this post? Once published, it will be visible to all users.'}
                      </p>
                    </>
                  )}
                </>
              )}

              {nameOfScreen === 'leads' && (
                <>
                  {isUpdate == 'update' && (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to Update this lead? Once saved, you
                      can edit or manage it later.
                    </p>
                  )}
                  {isUpdate !== 'update' && (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to save this lead? Once saved, you
                      can edit or manage it later.
                    </p>
                  )}
                </>
              )}
              {isUpdate === 'INVITE' ? (
                <p className='text-base text-gray-500 text-center mt-2'>
                  Are you sure you want to activate the dashboard for this
                  vendor? Since this is an Invite, the proposal will not be
                  shared, and the dashboard will be activated immediately.
                </p>
              ) : isUpdate === 'TRIAL' ? (
                <p className='text-base text-gray-500 text-center mt-2'>
                  Are you sure you want to activate the dashboard for this
                  vendor? Since this is an Trial, the proposal will not be
                  shared, and the dashboard will be activated immediately.
                </p>
              ) : isUpdate === 'adminInvite' ? (
                <p className='text-base text-gray-500 text-center mt-2'>
                  Are you sure you want to invite this vendor and activate their
                  dashboard? The vendor will receive an invitation email with
                  login details, and their dashboard will be activated
                  immediately.
                </p>
              ) : isUpdate === 'adminTrail' ? (
                <p className='text-base text-gray-500 text-center mt-2'>
                  Are you sure you want to trail this vendor and activate their
                  dashboard? The vendor will receive an invitation email with
                  login details, and their dashboard will be activated
                  immediately.
                </p>
              ) : (
                nameOfScreen === 'converToLeads' && (
                  <p className='text-base text-gray-500 text-center mt-2'>
                    Once converted, This proposal will be shared with the vendor
                    for review. Do you want to proceed?
                  </p>
                )
              )}

              {nameOfScreen === 'companies' && (
                <>
                  {isUpdate == 'update' && (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to Update this company? Once
                      updated, you can edit or manage it later.
                    </p>
                  )}
                  {isUpdate !== 'update' && (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to save this company? Once saved,
                      you can edit or manage it later.
                    </p>
                  )}
                </>
              )}

              {nameOfScreen === 'proposals' && (
                <>
                  {isUpdate == 'update' ? (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to Update this information?
                    </p>
                  ) : isUpdate == 'updateConfirmBooking' ? (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to update and share the revised
                      Order form with the vendor? Once updated, the vendor will
                      need to sign and reupload the form. The updated form will
                      replace the previous version in the vendor's UI.
                    </p>
                  ) : isUpdate == 'confirmBook' ? (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to generate and share the Order form
                      with the vendor? Once shared, the vendor will need to sign
                      and reupload the form to activate the contract/services.
                    </p>
                  ) : (
                    isUpdate !== 'update' &&
                    isUpdate !== 'TRIAL' &&
                    isUpdate !== 'INVITE' &&
                    isUpdate !== 'updateConfirmBooking' &&
                    isUpdate !== 'adminInvite' &&
                    isUpdate !== 'adminTrail' && (
                      <p className='text-base text-gray-500 text-center mt-2'>
                        Are you sure you want to save this proposal? Once saved,
                        you can edit or manage it later.
                      </p>
                    )
                  )}
                </>
              )}

              {nameOfScreen === 'bookings' && (
                <>
                  {isApproval == 'approval' && (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Are you sure you want to Update this booking? Once
                      updated, you can edit or manage it later.
                    </p>
                  )}
                  {isApproval !== 'approval' && (
                    <p className='text-base text-gray-500 text-center mt-2'>
                      Do you want to finalize the booking of the selected
                      services?
                      <>
                        {' '}
                        {bookingTypes === 'PAID' && (
                          <span>
                            Once confirmed, a order form will be generated.
                          </span>
                        )}
                      </>
                    </p>
                  )}
                </>
              )}

              {nameOfScreen === 'users' && (
                <p className='text-base text-gray-500 text-center mt-2'>
                  Are you sure you want to{' '}
                  {isUpdate == 'update' ? 'Update' : 'Submit'}?
                </p>
              )}
            </div>
          </div>
        </div>
        <div
          className='bg-white px-4 py-3 sm:px-6 sm:flex justify-center sm:flex-row-revers'
          style={{
            boxShadow: '0px -16px 50px 0px #0000000D',
          }}
        >
          <button
            type='button'
            className='mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm'
            onClick={onClose}
          >
            {nameOfScreen === 'bookings' ? 'Go Back' : 'Cancel'}
          </button>

          {(nameOfScreen === 'leads' || nameOfScreen === 'users') && (
            <>
              <button
                type='button'
                className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2'
                onClick={onConfirm}
              >
                {nameOfScreen === 'leads' ? 'Confirm' : 'Yes'}
              </button>
            </>
          )}
          {nameOfScreen === 'companies' && (
            <>
              <button
                type='button'
                className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2'
                onClick={onConfirm}
              >
                {nameOfScreen === 'companies' ? 'Confirm' : 'Yes'}
              </button>
            </>
          )}
          {isUpdate === 'INVITE' ? (
            <button
              type='button'
              className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mr-2'
              onClick={onConfirm}
            >
              Yes, Activate Dashboard
            </button>
          ) : isUpdate === 'TRIAL' ||
            isUpdate === 'adminTrail' ||
            isUpdate == 'adminInvite' ? (
            <button
              type='button'
              className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mr-2'
              onClick={onConfirm}
            >
              {isUpdate === 'TRIAL'
                ? 'Yes, Activate Dashboard '
                : isUpdate === 'adminTrail'
                ? 'Activate Dashboard '
                : 'Send Invite & Activate Dashboard '}
            </button>
          ) : (
            nameOfScreen === 'converToLeads' && (
              <>
                <button
                  type='button'
                  className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mr-2'
                  onClick={onConfirm}
                >
                  Confirm & Share
                </button>
              </>
            )
          )}
          {nameOfScreen === 'proposals' &&
            isUpdate !== 'TRIAL' &&
            isUpdate !== 'INVITE' &&
            isUpdate !== 'adminTrail' &&
            isUpdate !== 'adminInvite' && (
              <>
                <button
                  type='button'
                  className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2'
                  onClick={onConfirm}
                >
                  {nameOfScreen === 'proposals' && isUpdate == 'confirmBook'
                    ? 'Yes, Generate and Share'
                    : nameOfScreen === 'proposals' &&
                      isUpdate == 'updateConfirmBooking'
                    ? 'Yes, Update and Share'
                    : nameOfScreen === 'proposals'
                    ? 'Confirm'
                    : 'Yes'}
                </button>
              </>
            )}

          {nameOfScreen === 'bookings' && (
            <>
              <button
                type='button'
                className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2'
                onClick={onConfirm}
              >
                {nameOfScreen === 'bookings' ? 'Confirm and Proceed' : 'Yes'}
              </button>
            </>
          )}

          {nameOfScreen === 'posts' && (
            <>
              {isApproval === 'draft' && (
                <button
                  type='button'
                  className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mr-2'
                  onClick={onConfirm}
                >
                  Save as Draft
                </button>
              )}

              {/* If the post is approved and either published or overwritten */}
              {isApproval === 'approval' && (
                <button
                  type='button'
                  className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mr-2'
                  onClick={onConfirm}
                >
                  {isUpdate === 'update' && statusValue === 'PUBLISHED'
                    ? 'Overwrite'
                    : role === 'JE' ||
                      role === 'CE' ||
                      (role === 'Publisher' && userInfo?.roles !== 'PUBLISHER')
                    ? 'Send for Approval'
                    : 'Publish Now'}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;
